import { ApolloClient } from '@apollo/client';
import { SaasOrganisation } from 'src/graphql-types/saas-mesh/graphql';

export const isBrowser = typeof window !== 'undefined';

export interface CurrentUserVenue {
  VenueID: string;
  Name: string;
  VenueContactID: string;
  ChooseVenueInSchemes?: boolean;
  VenueSystemRoles: number;
  Scope: number;
  ModuleStatuses?: { Module: number; Status: number }[];
  Settings: {
    EnableNationalAdminAccess: boolean;
    EnableRegionalAdminAccess: boolean;
  };
}

export type VenueWithDetails = Pick<
  SaasOrganisation,
  | 'organisationId'
  | 'organisationName'
  | 'organisationType'
  | 'nationalAssociationSubType'
  | 'hierarchy'
  | 'parentOrganisation'
>;

export enum LoginError {
  NONE,
  GENERIC,
  NON_ADMIN,
  NO_USER,
  INVALID_SCOPE,
  UNAUTHENTICATED,
  TOO_MANY_ATTEMPTS,
}

export interface LoginProps {
  client: ApolloClient<object>;
  redirectUrl?: string;
}

export interface LoginNavState {
  redirectUrl?: string;
}

export enum AuthEvent {
  STATE_CHANGE = 'auth-state-change',
}

export enum AuthState {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  AUTHENTICATED = 'AUTHENTICATED',
}

export interface User {
  id: string;
  externalId?: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber?: string;
  systemRoles: number;
  isGlobalAdmin: boolean;
  status?: number;
  isFemale?: boolean;
  birthDate?: string;
  venueContacts?: any[];
}

export interface UserVenue {
  id: string;
  name: string;
  type: SaasOrganisation['organisationType'];
  nationalAssociationSubType: SaasOrganisation['nationalAssociationSubType'];
  hierarchy: SaasOrganisation['hierarchy'];
  parentOrganisation: SaasOrganisation['parentOrganisation'];
  venueSystemRoles: number;
  scope: number;
  tenantSettings: {
    enableNationalAdminAccess: boolean;
    enableRegionalAdminAccess: boolean;
  };
}
